(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceAddOnController', ServiceAddOnController);

    ServiceAddOnController.$inject = ['$rootScope', '$scope', '$state', 'ServiceAddOn', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'ServiceAddOnCustom', '$mdDialog', '$translatePartialLoader'];

    function ServiceAddOnController($rootScope, $scope, $state, ServiceAddOn, PersonInfo, Customer, ParseLinks, AlertService, entity, ServiceAddOnCustom, $mdDialog, $translatePartialLoader) {

        var vm = this;
        vm.serviceAddOn = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        initDefault();
        loadAll();

        function initDefault() {

            $rootScope.$broadcast('hideNavBar');

            if (!vm.serviceAddOn.status)
                vm.serviceAddOn.status = 'ACTIVE';

        }

        function loadAll() {
            $translatePartialLoader.addPart('serviceAddOn');
        }

        function save() {
            vm.isSaving = true;

            if (vm.serviceAddOn.id !== null) {
                ServiceAddOn.update(vm.serviceAddOn, onSaveSuccess, onSaveError);
            } else {

                ServiceAddOn.save(vm.serviceAddOn, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:serviceAddOnUpdate', result);
                vm.isSaving = false;
                closeModal();

            }

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.serviceAddOnList');

        }

        function getModalTitle() {
            if (vm.serviceAddOn.id)
                return 'tikonApp.serviceAddOn.home.edit';
            else
                return 'tikonApp.serviceAddOn.home.new';
        }
    }
})();
